import { BaseLoginError } from "./BaseLoginError";

export class UserBlockedNoActiveContract extends BaseLoginError {

    constructor(isShow: boolean) {
        super (isShow);
    }

}
